import React from 'react'
import { Link, useNavigate } from "react-router-dom"
import Header from "./Header"


function Login({ user, socket }) {
    const navigate = useNavigate()
    const s = socket.socket
    
    React.useEffect(() => { if( user ) {
        // if( window.history.length > 2 ) {
        //         navigate( -2 )
        // }else{
        //     navigate( '/' )
        // }
    } }, [ user ] )


    const handleLogin = () => {
        try{
            window.FB.login(( response ) => {
                if ( response ) {
                    window.FB.api('/me?fields=first_name, email, picture.width(250)', function( data ) {
                        // s.emit( 'loadOrCreate', data )
                    });
                    // User is logged in, handle the response (e.g., get access token)
                    // console.log( 'Logged in:', response );
                } else {
                    // User canceled login or didn't authorize
                    // console.log( 'Login canceled' );
                }
                }, { scope: 'public_profile,email' }); // Request necessary permissions
        }catch(e){
            console.log( e )
        }
    };

  return (
    <div className="pageWrapper">
        <Header headerContext='login'/>
        <div className='loginContentHolder'>
            <div className='fbLoginButtonHolder' >
                <button className='fbLoginButton' onClick={ handleLogin }>
                    <svg className='buttonIcon' viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.5 12.0441C24.5 5.39234 19.1274 -6.33409e-07 12.5 -6.33409e-07C5.87259 -6.33409e-07 0.5 5.39234 0.5 12.0441C0.5 17.6925 4.37432 22.432 9.60109 23.7335V15.7246H7.12659V12.0441H9.60109V10.4582C9.60109 6.35876 11.4495 4.45868 15.4594 4.45868C16.2196 4.45868 17.5314 4.60827 18.068 4.7579V8.09431C17.7848 8.0644 17.2929 8.04941 16.6817 8.04941C14.714 8.04941 13.9538 8.7975 13.9538 10.7425V12.0441H17.8734L17.2001 15.7246H13.9538V24C19.8955 23.2797 24.5 18.2019 24.5 12.0441Z" fill="white"/>
                    </svg>
                    Continue with Facebook
                </button>
                <Link to={ '/' }>
                    <button className="secondary_button">Lobby</button>
                </Link>
            </div>
        </div>
    </div>

  );
}

export default Login
